import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { PopupActionButton } from "../../buttonReusableComponent/ButtonReusableComponent";

export class ReusableSuccessMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  render() {
    const { open } = this.state;
    return (
      <div>
        <PopupActionButton
          buttonText={this.props.buttonText}
          buttonType="button"
          buttonClass="bigbuttongreen"
          onClick={this.onOpenModal}
        />
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div>
            <div className="reusble-popup-header-style">
              <h4>{this.props.bigText}</h4>
            </div>
            {this.props.display === true ? (
              <div className="bottom-button mb-4">
                <p className="col-12 mt-0 mb-0">{this.props.smallText}</p>
              </div>
            ) : (
              <div className="bottom-button mb-4 Center-text-box">
                <div>
                  <p className="col-12">{this.props.smallText}</p>
                  <h5 className="col-12">{this.props.successText}</h5>
                </div>
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

export default ReusableSuccessMessage;
